import { TGetCompanyDto } from "@/api/services/main/company/dtos/get-company.dto";
import { useGetIndustryList } from "@/api/services/global/industry";
import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { text } from "@/theme/colors";
import { spacing } from "@/theme/variables";
import { FCC } from "@/types/common";
import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { EMPTY_STR } from "@/constants/string";

type TCompanyHandledIndustryDetailSectionProps = {
  companyData: TGetCompanyDto;
};

/**
 * 取り扱う分野 (read-only) — company detail view, mirrors the RSO detail section.
 * Shows only industries that are ON (i.e. not present in hiddenIndustryIds).
 */
export const CompanyHandledIndustryDetailSection: FCC<TCompanyHandledIndustryDetailSectionProps> = ({ companyData }) => {
  const { data: publishedIndustries } = useGetIndustryList();

  const visibleIndustries = useMemo(() => {
    const hidden = new Set((companyData.hiddenIndustryIds ?? []).map(Number));
    return publishedIndustries.filter((ind) => !hidden.has(Number(ind.id)));
  }, [publishedIndustries, companyData.hiddenIndustryIds]);

  return (
    <InnerBox title={<CompanyFormTitle text="取り扱う分野" />} showDivider={false}>
      <Stack gap={spacing.sm} mt={1}>
        {visibleIndustries.length === 0 ? (
          <Typography variant="body14" color={text.tertiary}>
            {EMPTY_STR.TEXT}
          </Typography>
        ) : (
          visibleIndustries.map((industry) => (
            <Typography key={industry.id} variant="body14" color={text.primary}>
              {industry.name}
            </Typography>
          ))
        )}
      </Stack>
    </InnerBox>
  );
};
